export enum PrePostingStatus {
  Pending = 0,
  Processing = 1,
  Ready = 2,
  Failed = 3,
  Cancelled = 4
};
